// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"0b0e0799","248":"b383fa82","258":"c709d094","312":"b4d7be9f","359":"733889ef","495":"ff2769d1","521":"3b268681","573":"c62331e7","704":"5e1c56a6","732":"0a2a1411","963":"49a3cc12"}[chunkId] + ".chunk.js";
};